/* eslint-disable react/prop-types */
import React from 'react';

const ShippingMethod = ({
  shippingMethods,
  selectedShippingMethod,
  setSelectedShippingMethod,
  selectedShipmentMethod,
  setSelectedShipmentMethod,
  selectedExternalShipmentMethod,
  setSelectedExternalShipmentMethod,
  selectedShipmentAddress,
  setSelectedShipmentAddress,
}) => {
  const selectShippingMethod = method => {
    setSelectedShippingMethod(method);
    setSelectedShipmentMethod(null);
    setSelectedShipmentAddress(null);
    setSelectedExternalShipmentMethod(null);
  };

  return (
    <div className="bg-white shadow-c-sm rounded-card p-4">
      <p className="text-primary text-xl leading-6 font-medium ">
        Shipping Method
      </p>
      <div className=" mt-5 flex items-center flex-wrap gap-3">
        {shippingMethods?.map(method => {
          return (
            method.type === 'pickup' && (
              <button
                className={
                  selectedShippingMethod?.id !== method.id
                    ? '    px-2 py-1 border border-gray-300 flex items-start justify-between rounded-button    transition duration-700    hover:border-primary hover:text-primary gap-3'
                    : '  px-2 py-1 border  flex items-start justify-between   border-transparent bg-primary text-white rounded-button cursor-pointer  ring-2 ring-primary ring-offset-2  gap-3'
                }
                key={method.id}
                onClick={() => selectShippingMethod(method)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={[
                    'h-5 w-5  mt-0.5   ',
                    selectedShippingMethod?.id === method.id
                      ? ''
                      : 'text-gray-500',
                  ].join(' ')}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className=" text-base   font-semibold ">
                  {method.name}
                </span>
              </button>
            )
          );
        })}
      </div>
      {selectedShippingMethod && selectedShippingMethod?.note && (
        <div
          className="mt-2 bg-green-100 border-t-2 border-green-500 rounded-b text-green-900 px-4 py-2 shadow-md"
          role="alert">
          <div className="flex items-start">
            <svg
              className="fill-current h-4 w-4 text-green-500 mr-4 mt-0.5 flex-none"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20">
              <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
            </svg>

            <div className="flex-grow">
              <p className="text-sm">{selectedShippingMethod?.note}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShippingMethod;
